import { render, staticRenderFns } from "./singleSelect.vue?vue&type=template&id=6b896fdf&scoped=true&"
import script from "./singleSelect.vue?vue&type=script&lang=js&"
export * from "./singleSelect.vue?vue&type=script&lang=js&"
import style0 from "./singleSelect.vue?vue&type=style&index=0&id=6b896fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b896fdf",
  null
  
)

export default component.exports